import React from "react"

import {MC} from './MC.js'
import HtmlCustom from "./HtmlCustom.jsx"

class Link extends React.Component {

  handleClick = (e) => {
    const field = this.props.data
    if (MC.isModelerActive(field)) {
      return
    }
    const url = MC.getFieldParamValue(field.param, '@url')
    if (MC.eventHasKey(e) && !MC.isNull(url)) {
      return
    }
    const behavior = MC.getFieldParamValue(field.param, '@behavior')
    if (behavior != 'url') {
      e.preventDefault()
    }
    const escapeHtml = MC.getFieldParamBooleanValue(field.param, '@escapeHtml')
    if (escapeHtml === false && e.target.nodeName !== 'A') {
      if (behavior != 'url' || !MC.isNullOrEmpty(href)) {
        return
      }
    }
    if (MC.isFunction(this.props.onClick) && !MC.isModelerActive(this.props.data)) {
      this.props.onClick()
    }
    MC.handleEvent(field, 'click', null, e)
    if (behavior == 'url') {
      if (!MC.isNull(url)) {
        let target = MC.getFieldParamValue(field.param, '@target')
        if (['blank', 'parent', 'top'].indexOf(target) > -1) {
          return
        }
        field.flow.routeTo(e, MC.rebaseLink(field.flow, url) )
        return
      }
    } else {
      this.props.data.flow.handleSubmit(this.props.data)
    } 
  }

  handleDblClick = (e) => {
    MC.handleEvent(this.props.data, 'doubleclick', null, e)
  } 

  render() {
    const field = this.props.data
    let title = this.props.value
    let escapeHtml = MC.getFieldParamBooleanValue(field.param, '@escapeHtml')
    let cls = this.props.cls ? this.props.cls : MC.classes(MC.getFieldParamValue(field.param, '@cssClass'), {'mnc link curpointer' : escapeHtml !== false, 'icon': MC.isNullOrEmpty(title)})
    let css = MC.styleObjectFromString(MC.getFieldParamValue(field.param, '@css'))
    let href = MC.rebaseLink(field.flow, MC.getFieldParamValue(field.param, '@url'))
    let imageUrl = MC.getFieldParamValue(field.param, '@imageUrl')
    if (!MC.isNull(imageUrl)) {
      imageUrl = MC.rebaseUrl(field.flow, imageUrl)
      if (MC.getFieldParamValue(field.param, '@iconPlacement') === 'right') {
        title = <React.Fragment>{title}<img src={imageUrl}/></React.Fragment>
      } else {
        title = <React.Fragment><img src={imageUrl}/>{title}</React.Fragment>
      }
    } else if (escapeHtml !== false) {
      title = MC.iconize(field, <span>{title}</span>)
    }
    if (this.props.disabled) {
      return <span id={field.rbsid} className={cls} style={css} ref={this.props.widgetRef}>{title}</span>
    } else {
      let target = MC.getFieldParamValue(field.param, '@target')
      if (['blank', 'parent', 'top'].indexOf(target) > -1) {
        target = '_' + target
      } else {
        target = null
      }
      if (escapeHtml !== false) {
        return <a className={cls} style={css} id={field.rbsid} onClick={this.handleClick} onDoubleClick={this.handleDblClick} href={href} target={target} data-widget-i-name={field.id} ref={this.props.widgetRef}>{title}</a>
      } else {
        const behavior = MC.getFieldParamValue(field.param, '@behavior')
        if (behavior == 'url' && !MC.isNullOrEmpty(href)) {
          return <a className={cls} style={css} id={field.rbsid} onClick={this.handleClick} onDoubleClick={this.handleDblClick} href={href} target={target} data-widget-i-name={field.id} ref={this.props.widgetRef}><HtmlCustom Tag="div" html={title} /></a>
        } else {
          return <HtmlCustom Tag="div" className={cls} style={css} id={field.rbsid} onClick={this.handleClick} onDoubleClick={this.handleDblClick} html={title} data-widget-i-name={field.id} ref={this.props.widgetRef} />
        }
      }
    }
  }

}

export {Link}